import { server_connection } from 'config';
import store from 'store';
import { getAllQuizzes as lessonGetAllQuizzes } from '../../../lesson/store/actions';
import { getRelatedData as lessonGetRelatedData } from '../../../lesson/store/actions';
import { getContentLabelList } from '../../../content_label/store/actions';
import history from 'history.js';

export const GET_QUIZ                     = '[QUIZ APP] GET QUIZ';
export const UPDATE_QUIZ_FORM             = '[QUIZ APP] UPDATE QUIZ FORM';
export const UPDATE_QUIZ_LABELS           = '[QUIZ APP] UPDATE QUIZ LABELS';
export const CLEAR_QUIZ                   = '[QUIZ APP] CLEAR QUIZ';
export const ADD_QUESTION                 = '[QUIZ APP] ADD QUESTION';
export const ADD_ANSWER                   = '[QUIZ APP] ADD ANSWER';
export const UPDATE_QUESTION              = '[QUIZ APP] UPDATE QUESTION';
export const UPDATE_ANSWER                = '[QUIZ APP] UPDATE ANSWER';
export const DELETE_ANSWER                = '[QUIZ APP] DELETE ANSWER';
export const DELETE_QUESTION              = '[QUIZ APP] DELETE QUESTION';
export const SAVE_QUIZ                    = '[QUIZ APP] SAVE QUIZ';
export const MOVE_QUESTION                = '[QUIZ APP] MOVE QUESTION';
export const MOVE_ANSWER                  = '[QUIZ APP] MOVE ANSWER';
export const GET_QUIZ_LIST                = '[QUIZ APP] GET QUIZ LIST';
export const VIEW_QUESTION                = '[QUIZ APP] VIEW QUESTION';
export const CHANGE_QUESTION_TYPE         = '[QUIZ APP] CHANGE QUESTION TYPE';
export const RANDOMIZE_QUIZ               = '[QUIZ APP] RANDOMIZE QUESTION ORDER';
export const ORDER_ANSWER_LIST            = '[QUIZ APP] ORDER ANSWER LIST';
export const SWAP_ANSWER_LIST             = '[QUIZ APP] SWAP ANSWER LIST';
export const GET_EDIT_INFO                = '[QUIZ APP] GET EDIT INFO';
export const UPDATE_QUESTION_IMAGE        = '[QUIZ APP] UPDATE QUESTION IMAGE';
export const ADD_QUESTION_IMAGE_SHAPE     = '[QUIZ APP] ADD QUESTION IMAGE SHAPE';
export const UPDATE_QUESTION_IMAGE_SHAPE  = '[QUIZ APP] UPDATE QUESTION IMAGE SHAPE';
export const REMOVE_QUESTION_IMAGE_SHAPE  = '[QUIZ APP] REMOVE QUESTION IMAGE SHAPE';
export const REPLACE_QUESTION_IMAGE_SHAPE = '[QUIZ APP] REPLACE QUESTION IMAGE SHAPE';
export const UPDATE_NEW_QUIZ_NAME         = '[QUIZ APP] UPDATE NEW QUIZ NAME';
export const TOGGLE_QUIZ_REPULL           = '[QUIZ APP] TOGGLE QUIZ REPULL';
export const AUTO_CALC_QUESTION_POINTS    = '[QUIZ APP] AUTO CALC QUESTION POINTS';
export const UPDATE_QUIZ_LIST_LOADED      = '[QUIZ APP] UPDATE QUIZ LIST LOADED';
export const GET_QUIZ_GRADEBOOK_INFO      = '[QUIZ APP] GET QUIZ GRADEBOOK INFO';

export const LOCK_QUIZ = '[QUIZ APP] LOCK QUIZ';
export const UNLOCK_QUIZ = '[QUIZ APP] UNLOCK QUIZ';

export const TOGGLE_COMPANY                 = '[QUIZ APP] TOGGLE COMPANY';
export const COMPANY_UPDATE_SEARCH          = '[QUIZ APP] COMPANY UPDATE SEARCH';
export const GET_COMPANY_LIST               = '[QUIZ APP] GET COMPANY LIST';
export const ACTIVATE_QUIZ                  = '[QUIZ APP] ACTIVATE QUIZ';

export function getQuizList(call_location) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/quiz/list/' + auth_id)
            .then((response) => response.json())
            .then((quizList) => {
                return dispatch({
                    type: GET_QUIZ_LIST,
                    payload: {quizList, call_location},
                });
            });
    }
}

export function updateQuizListLoaded(setting) {
    return {
        type: UPDATE_QUIZ_LIST_LOADED,
        payload: setting
    }
}

export function getQuiz(quiz_id, randomize_quiz = false) {
    return (dispatch) => {
        fetch(server_connection + '/quiz/get/' + quiz_id)
            .then((response) => response.json())
            .then((quizData) => {
                return dispatch({
                    type: GET_QUIZ,
                    payload: quizData
                });
            })
            .then(() => {
                if (randomize_quiz) {
                    return dispatch({
                        type: RANDOMIZE_QUIZ
                    });
                }
            });
    }
}

export function getCompanyList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((companyList) => {
                dispatch({
                    type: GET_COMPANY_LIST,
                    payload: companyList,
                });
            });
    }
}

export function getQuizByEventID(event_id, randomize_quiz = false, student_id) {
    let return_data = true;
    return (dispatch) => {
        fetch(server_connection + '/quiz/get_by_event_for_student/' + event_id + '/' + student_id)
            .then((response) => response.json())
            .then((quizData) => {
                if (!quizData.header) {
                    return_data = false;
                    return history.push({
                        pathname: '/dashboard'
                    })
                }
                else {
                    return dispatch({
                        type: GET_QUIZ,
                        payload: {quiz: quizData}
                    });
                }

                
            })
            .then(() => {
                if (randomize_quiz && !!return_data) {
                    return dispatch({
                        type: RANDOMIZE_QUIZ
                    });
                }
            });
    }
}

export function getQuizGradebookInfoByEventID(event_id, student_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/quiz/gradebook_info/' + event_id +'/' + student_id)
            .then((response) => response.json())
            .then((info) => {
                return dispatch({
                    type: GET_QUIZ_GRADEBOOK_INFO,
                    payload: info,
                });
            });
    }
}

export function updateQuizBuilder(quiz_data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUIZ_FORM,
            payload: quiz_data
        });
        
        dispatch({
            type: AUTO_CALC_QUESTION_POINTS
        });
    }
}

export function updateQuizLabels(quiz_data) {
    return {
        type: UPDATE_QUIZ_LABELS,
        payload: quiz_data
    }
}

export function clearQuiz() {
    return (dispatch) => {
        return dispatch({
            type: CLEAR_QUIZ,
        });
    }
}

export function addQuestion(quiz_id, setScrollTo) {
    return (dispatch, getState) => {
        dispatch({
            type: ADD_QUESTION,
            payload: quiz_id
        });

        dispatch({
            type: AUTO_CALC_QUESTION_POINTS
        });
        
        const question_id = 'new_' + store.getState().quizApp.quizzes.currentQuiz.newQuestionCount;
        setScrollTo(question_id);
    }
}

export function addAnswer(question_id) {
    return (dispatch) => {
        return dispatch({
            type: ADD_ANSWER,
            payload: question_id
        });
    }
}

export function updateQuestion(question_id, question_data, is_on_blur=false) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUESTION,
            payload: { question_id, question_data } 
        });

        if (is_on_blur) {
            dispatch({
                type: AUTO_CALC_QUESTION_POINTS,
                payload: { question_id },
            });
        }
    }
}

export function updateAnswer(question_id, answer_id, answer_data) {
    return (dispatch) => {
        return dispatch({
            type: UPDATE_ANSWER,
            payload: { question_id, answer_id, answer_data }
        });
    }
}

export function deleteAnswer(question_id, answer_id) {
    return (dispatch) => {
        return dispatch({
            type: DELETE_ANSWER,
            payload: { question_id, answer_id }
        });
    }
}

export function deleteQuestion(question_id) {
    return (dispatch) => {
        dispatch({
            type: DELETE_QUESTION,
            payload: question_id
        });

        dispatch({
            type: AUTO_CALC_QUESTION_POINTS
        });
    }
}

export function deleteQuizBuilder(quiz_id) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        fetch(server_connection + '/quiz/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz_id: quiz_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch(getQuizList('actions')),
                    dispatch(lessonGetAllQuizzes()),
                    dispatch(lessonGetRelatedData(store.getState().paramHistory.courseBuilder.lesson_id))
                ])

            });
    }
}

export function saveQuiz(quiz, auth_id, event_course_status, companies) {
    const newQuiz = {
        ...quiz,
        header: {
            ...quiz.header,
            CreateAuthID: auth_id,
            LastEditAuthID: auth_id,
            labels: quiz.labels,
            companies
        }
    }

    return (dispatch) => {
        fetch(server_connection + '/quiz/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz: newQuiz, event_course_status: event_course_status, companies })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch(getQuizList('actions')),
                    dispatch(lessonGetAllQuizzes()),
                    dispatch(lessonGetRelatedData(store.getState().paramHistory.courseBuilder.lesson_id))
                ])
            });
    }
}

export function saveQuizCopy(quiz, auth_id, companies) {
    const newQuiz = {
        ...quiz,
        header: {
            ...quiz.header,
            CreateAuthID: auth_id,
            LastEditAuthID: auth_id
        }
    }

    return (dispatch) => {
        fetch(server_connection + '/quiz/save_copy',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz: newQuiz, companies })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch(getQuizList('actions')),
                    dispatch(toggleQuizRepull(true)),
                    // dispatch(lessonGetRelatedData(store.getState().paramHistory.courseBuilder.lesson_id))
                    history.push({
                        pathname: '/quiz/edit/' + responseData.quiz_id
                    })
                ])
            });
    }
}

export function lockQuiz(quiz_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/quiz/lock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: LOCK_QUIZ,
                    payload: auth_id
                });
            });
    }
}

export function unlockQuiz(quiz_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/quiz/unlock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: UNLOCK_QUIZ,
                    payload: true,
                });
            });
    }
}

export function activateQuiz(quiz_id, auth_id, lessons) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/quiz/activate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz_id, auth_id, lessons })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: ACTIVATE_QUIZ,
                    payload: true,
                });
            });
    }
}

export function toggleQuizRepull(setting) {
    return {
        type: TOGGLE_QUIZ_REPULL,
        payload: setting
    }
}

export function getEditInfo(quiz_id) {
    return (dispatch, getState) => {
        return fetch(server_connection + '/quiz/get/edit_info/' + quiz_id)
            .then((response) => response.json())
            .then((data) => {
                return dispatch({
                    type: GET_EDIT_INFO,
                    payload: data
                });
            });
    }
}

export function moveQuestion(question_id, display_order, direction) {
    return (dispatch) => {
        return dispatch({
            type: MOVE_QUESTION,
            payload: { question_id, display_order, direction }
        });
    }
}

export function moveAnswer(question_id, answer_id, display_order, direction) {
    return (dispatch) => {
        return dispatch({
            type: MOVE_ANSWER,
            payload: { question_id, answer_id, display_order, direction }
        });
    }
}

export function viewQuestion(question_id) {
    return (dispatch) => {
        return dispatch({
            type: VIEW_QUESTION,
            payload: question_id
        })
    }
}

export function changeQuestionType(question_id, question_type_id) {
    return (dispatch) => {
        return dispatch({
            type: CHANGE_QUESTION_TYPE,
            payload: { question_id, question_type_id }
        })
    }
}

export function randomizeQuiz() {
    return (dispatch, getState) => {
        dispatch({
            type: RANDOMIZE_QUIZ
        });
    }
}

export function reorderAnswerList(list_type, question_id, source_index, destination_index) {
    return (dispatch) => {
        dispatch({
            type: ORDER_ANSWER_LIST,
            payload: { list_type, question_id, source_index, destination_index }
        });
    }
}

export function swapAnswerList(question_id, source, destination) {
    return (dispatch) => {
        dispatch({
            type: SWAP_ANSWER_LIST,
            payload: { question_id, source, destination }
        });
    }
}

export function updateQuestionImage(question_id, asset_id, AssetName, URL) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUESTION_IMAGE,
            payload: { question_id, asset_id, AssetName, URL }
        });
    }
}

export function addQuestionImageShape(question_id, shape_info) {
    return (dispatch) => {
        dispatch({
            type: ADD_QUESTION_IMAGE_SHAPE,
            payload: { question_id, shape_info }
        });
    }
}

export function updateQuestionImageShape(question_id, shape_info) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUESTION_IMAGE_SHAPE,
            payload: { question_id, shape_info }
        });
    }
}

export function removeQuestionImageShape(question_id, shape_id) {
    return (dispatch) => {
        dispatch({
            type: REMOVE_QUESTION_IMAGE_SHAPE,
            payload: { question_id, shape_id }
        });
    }
}

export function replaceQuestionImageShape(question_id, shape_list) {
    return (dispatch) => {
        dispatch({
            type: REPLACE_QUESTION_IMAGE_SHAPE,
            payload: { question_id, shape_list }
        })
    }
}

export function updateNewQuizName(data) {
    return {
        type: UPDATE_NEW_QUIZ_NAME,
        payload: data
    }
}

export function autoCalcQuestionPoints() {
    return {
        type: AUTO_CALC_QUESTION_POINTS
    }
}

export function companyUpdateSearch(characters) {
    return {
        type: COMPANY_UPDATE_SEARCH,
        payload: characters
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: { company, action_type }
    }
}


// WEBPACK FOOTER //
// src/main/content/quiz/store/actions/quiz.actions.js